<template>
  <div id="app">
    <div id="header" class="box-shadow">
      <h1 id="title">Welcome to the APUSH Exam Countdown!</h1>
    </div>
    <div id="container">
      <div id="img-container">
        <img src="./assets/heimler.jpg" style="width:400px"/>
      </div>

      <HelloWorld id="hw" msg="Welcome to Your Vue.js App" />
    </div>
    <div class="marquee">
      <h1>Don't forget to study!</h1>
    </div>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "app",
  components: {
    HelloWorld
  }
};
</script>

<style>
#header {
  width: 100va;
  background-color: white;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;

  background: linear-gradient(
    124deg,
    #ff2400,
    #e81d1d,
    #e8b71d,
    #e3e81d,
    #1de840,
    #1ddde8,
    #2b1de8,
    #dd00f3,
    #dd00f3
  );
  background-size: 1800% 1800%;

  -webkit-animation: rainbow 18s ease infinite;
  -z-animation: rainbow 18s ease infinite;
  -o-animation: rainbow 18s ease infinite;
  animation: rainbow 18s ease infinite;
}

.marquee {
  display: block;
  min-width: 100%;
  font-size: 3vh;
  color: limegreen;
  position: absolute;
  height: 100%;
  margin: 0;
  line-height: 50px;
  text-align: center;
  white-space: nowrap;

  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);

  animation: marquee 10s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(calc(60vw));
  }
  100% {
    transform: translateX(calc(-150%));
  }
}

.container {
  max-width: 100%;
}

#img-container {
  flex: 1 1 auto;
  height: 40%;
  margin-top: 20px;
}

#img-container > img {
  max-height: 100%;
  max-width: 40%;
  min-width: 300px;
}

.box-shadow {
  content: "";
  box-shadow: 0px 0px 8px 2px black;
}

#title {
  font-size: 40px;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: middle;
}

body {
  margin: 0;
  background-color: darkslategrey;
  color: white;

  opacity: 1;
  transition: 0.7s opacity;
}

body.fade {
  opacity: 0;
  transition: none;
}

#app {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  /* margin-top: 60px; */
}

@-webkit-keyframes rainbow {
  0% {
    background-position: 0% 82%;
  }
  50% {
    background-position: 100% 19%;
  }
  100% {
    background-position: 0% 82%;
  }
}
@-moz-keyframes rainbow {
  0% {
    background-position: 0% 82%;
  }
  50% {
    background-position: 100% 19%;
  }
  100% {
    background-position: 0% 82%;
  }
}
@-o-keyframes rainbow {
  0% {
    background-position: 0% 82%;
  }
  50% {
    background-position: 100% 19%;
  }
  100% {
    background-position: 0% 82%;
  }
}
@keyframes rainbow {
  0% {
    background-position: 0% 82%;
  }
  50% {
    background-position: 100% 19%;
  }
  100% {
    background-position: 0% 82%;
  }
}
</style>
